import Button from "@restart/ui/esm/Button";
import { Modal } from "react-bootstrap";
import './Myworks.css'
function Doctor(props) {
    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title  id="contained-modal-title-vcenter">
           Doctors-Care Portal
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4>My Project skills</h4>
         <ol>
             <li>ReactJs</li>
             <li>React-Bootstrap</li>
             <li>Vanila Css</li>
         </ol>

           
    
          <Button className='button'><a style={{textDecoration:'none'}} href='https://doctors-care-21f96.web.app/' >Live link </a> </Button>
         
        </Modal.Body>
        <Modal.Footer>
          <Button className='button' onClick={props.onHide}>Close</Button>
        </Modal.Footer>
      </Modal>
    );
  };
  export default Doctor;